import { Constants } from './types'

export const toggleFieldAction = (bool: boolean) => {
  return {
    type: Constants.SET_TOGGLE,
    payload: bool,
  }
}
